export type AppEnvironment = 'development' | 'staging' | 'production';

function resolveAppEnv(): AppEnvironment {
  const mode = import.meta.env.MODE;

  return mode === 'staging' ? 'staging' : mode === 'production' ? 'production' : 'development';
}

export const appEnv = resolveAppEnv();

export const isLocal = appEnv === 'development';

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  recaptchaKey: import.meta.env.VITE_FIREBASE_RECAPTCHA_SITE_KEY,
  appCheckDebugKey: import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN
};

export const sentryConfig = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0.1),
  replaysSessionSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || 0),
  replaysOnErrorSampleRate: Number(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || 1)
};
